export default __webpack_public_path__ + "static/media/youtube-play-icon.7cedfa3a.png";